(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bikini-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  function esc(v){var d=document.createElement('div');d.textContent=v==null?'':String(v);return d.innerHTML}
  function Config(root){
    this.root=root;
    this.handles={top:root.dataset.top,slip:root.dataset.slip};
    this.data={top:{items:[],query:'',color:'',model:'',size:'',visible:12,product:null,variant:null,loaded:false},slip:{items:[],query:'',color:'',model:'',size:'',visible:12,product:null,variant:null,loaded:false}};
    this.currency=window.Shopify&&Shopify.currency?Shopify.currency.active:'EUR';
    this.locale=document.documentElement.lang||'it-IT';
    this.bind();
    this.load('top');
  }
  Config.prototype.money=function(c){return new Intl.NumberFormat(this.locale,{style:'currency',currency:this.currency}).format((Number(c)||0)/100)};
  Config.prototype.bind=function(){
    var self=this;
    this.root.querySelectorAll('[data-search]').forEach(function(el){el.addEventListener('input',function(){var t=el.dataset.search;self.data[t].query=el.value.trim().toLowerCase();self.data[t].visible=12;self.grid(t)})});
    this.root.addEventListener('click',function(e){
      var b=e.target.closest('[data-filter-button]');
      if(!b||!self.root.contains(b))return;
      var t=b.dataset.filterButton,k=b.dataset.filterKind,v=b.dataset.filterValue||'';
      self.data[t][k]=v;self.data[t].visible=12;
      self.root.querySelectorAll('[data-filter-button="'+t+'"][data-filter-kind="'+k+'"]').forEach(function(x){x.classList.toggle('is-active',(x.dataset.filterValue||'')===v)});
      self.grid(t);
    });
    this.root.querySelectorAll('[data-reset]').forEach(function(el){el.addEventListener('click',function(){
      var t=el.dataset.reset,d=self.data[t];d.query='';d.color='';d.model='';d.size='';d.visible=12;
      var search=self.root.querySelector('[data-search="'+t+'"]');if(search)search.value='';
      self.root.querySelectorAll('[data-filter-button="'+t+'"]').forEach(function(x){x.classList.toggle('is-active',(x.dataset.filterValue||'')==='')});
      self.grid(t)
    })});
    this.root.querySelectorAll('[data-more]').forEach(function(el){el.addEventListener('click',function(){var t=el.dataset.more;self.data[t].visible+=12;self.grid(t)})});
    this.root.querySelectorAll('[data-scroll-arrow]').forEach(function(el){el.addEventListener('click',function(){
      var t=el.dataset.scrollArrow,grid=self.root.querySelector('[data-grid="'+t+'"]');
      if(!grid)return;
      grid.scrollBy({left:Math.max(grid.clientWidth*.78,240),behavior:'smooth'});
      setTimeout(function(){self.updateScrollArrow(t)},420);
    })});
    this.root.querySelectorAll('[data-grid]').forEach(function(grid){grid.addEventListener('scroll',function(){self.updateScrollArrow(grid.dataset.grid)},{passive:true})});
    this.root.querySelectorAll('[data-back]').forEach(function(el){el.addEventListener('click',function(){self.go(el.dataset.back)})});
    this.root.querySelectorAll('[data-jump]').forEach(function(el){el.addEventListener('click',function(){if(!el.disabled)self.go(el.dataset.jump)})});
    this.root.querySelectorAll('[data-mini-add]').forEach(function(el){el.addEventListener('click',function(){self.add(this)})});
  };
  Config.prototype.fetchPage=async function(handle,page){
    var base=window.Shopify&&Shopify.routes?Shopify.routes.root:'/';
    var r=await fetch(base+'collections/'+encodeURIComponent(handle)+'?view=configurator-data&page='+page,{credentials:'same-origin'});
    if(!r.ok)throw new Error('load');
    var doc=new DOMParser().parseFromString(await r.text(),'text/html');
    var node=doc.querySelector('[data-hb-configurator-data]');
    if(!node)throw new Error('data');
    return JSON.parse(node.textContent);
  };
  Config.prototype.load=async function(type){
    var self=this,d=this.data[type],status=this.root.querySelector('[data-status="'+type+'"]');
    status.textContent='Caricamento modelli…';
    try{
      var first=await this.fetchPage(this.handles[type],1);
      d.items=first.products||[];status.textContent='';this.grid(type);
      for(var p=2;p<=Number(first.pages||1);p++){var more=await this.fetchPage(this.handles[type],p);d.items=d.items.concat(more.products||[]);this.grid(type)}
      d.loaded=true;this.prepare(type);this.grid(type);
    }catch(e){status.textContent='Impossibile caricare i prodotti. Riprova.'}
  };
  Config.prototype.clean=function(v){return String(v||'').trim().replace(/\s+/g,' ')};
  Config.prototype.colorOf=function(p){
    var c=this.clean(p.color);
    if(c&&c.toLowerCase()!=='default title')return c;
    var tags=(p.tags||[]).filter(function(t){var x=String(t).toLowerCase();return x!=='top'&&x!=='slip'&&x!=='getsync_ignored'});
    return tags.length?this.clean(tags[0]):'';
  };
  Config.prototype.colorFamilyOf=function(value){
    var v=this.clean(value).toLowerCase();
    if(!v)return 'Fantasia';
    if(/sfumato|\/|zebr|tarocchi|fruit|spiral|sprial|fantasia|multicolor/.test(v))return 'Fantasia';
    if(/nero|black/.test(v))return 'Nero';
    if(/bianco|white/.test(v))return 'Bianco';
    if(/rosso|red|anguria/.test(v))return 'Rosso';
    if(/baby doll|rosa|pink|fucsia|magenta|cipria|bocciolo/.test(v))return 'Rosa';
    if(/blu|navy|mirtillo|mavi|royal/.test(v))return 'Blu';
    if(/verde|foresta|ottanio/.test(v))return 'Verde';
    if(/viola|prugna|malva/.test(v))return 'Viola';
    if(/marrone|brule|brul[eé]|anfora|tiramisu|cacao|cioccolato/.test(v))return 'Marrone';
    if(/arancio|arancione|spritz|pesca|peach/.test(v))return 'Arancio';
    if(/giallo|oro|lusso/.test(v))return 'Giallo';
    return 'Fantasia';
  };
  Config.prototype.modelsOf=function(type,p){
    var title=this.clean(p.title).toLowerCase();
    var desc=this.clean(p.description).toLowerCase();
    var text=title+' '+desc;
    var tags=(p.tags||[]).map(function(t){return String(t).trim().toLowerCase()});
    var out=[];
    function add(v){if(out.indexOf(v)===-1)out.push(v)}
    var manualMap=type==='top'
      ? {
          'hb_push_up':'Push up',
          'hb_senza_push_up':'Senza push up',
          'hb_fascia':'Fascia',
          'hb_triangolo':'Triangolo',
          'hb_balconcino':'Balconcino',
          'hb_curvy':'Curvy'
        }
      : {
          'hb_brasiliano':'Brasiliano',
          'hb_regolare':'Regolare',
          'hb_vita_alta':'Vita alta',
          'hb_perizoma':'Perizoma'
        };
    var hasManual=false;
    tags.forEach(function(t){
      if(manualMap[t]){hasManual=true;add(manualMap[t])}
    });
    if(hasManual)return out;
    if(type==='top'){
      var isPush=/push[ -]?up|super push|effetto volume|una taglia in pi[uù]/i.test(text);
      var isTriangle=/triangol/i.test(text);
      var isBand=/fascia/i.test(text);
      var isCurvy=/\bmatilde\b|\bhelena\b|coppa d|forme pi[uù] generose|taglia 10\^|taglia 9\^|taglia 8\^/i.test(text);
      var isBalconette=/balconcino|ferretto/i.test(text) && !isTriangle && !isBand;
      if(isPush)add('Push up');
      if(!isPush || /senza push[ -]?up/i.test(text))add('Senza push up');
      if(isBand)add('Fascia');
      if(isTriangle)add('Triangolo');
      if(isBalconette)add('Balconcino');
      if(isCurvy)add('Curvy');
    }else{
      var isHigh=/vita alta/i.test(text);
      var isThong=/perizoma/i.test(title);
      var isBrazil=/brasilian/i.test(text) && !isHigh && !isThong;
      var isRegular=/regolare/i.test(text);
      if(isBrazil)add('Brasiliano');
      if(isRegular)add('Regolare');
      if(isHigh)add('Vita alta');
      if(isThong)add('Perizoma');
      if(out.length===0)add('Regolare');
    }
    return out;
  };
  Config.prototype.sizeOfVariant=function(v){
    var t=this.clean(v&&v.title);
    if(!t||t==='Default Title')return '';
    var parts=t.split(' / ');
    var s=this.clean(parts[parts.length-1]);
    return s;
  };
  Config.prototype.prepare=function(type){
    var self=this,d=this.data[type];
    d.items.forEach(function(p){p.filterColor=self.colorFamilyOf(self.colorOf(p));p.filterModels=self.modelsOf(type,p)});
    var colorOrder=['Nero','Bianco','Rosso','Rosa','Blu','Verde','Viola','Marrone','Arancio','Giallo','Fantasia'];
    var present=new Set(d.items.filter(function(p){return p.available}).map(function(p){return p.filterColor}));
    var colors=colorOrder.filter(function(v){return present.has(v)});
    var models=type==='top'
      ? ['Push up','Senza push up','Fascia','Triangolo','Balconcino','Curvy']
      : ['Brasiliano','Regolare','Vita alta','Perizoma'];
    function swatch(v){
      return {'Nero':'#222222','Bianco':'#f5f3ee','Rosso':'#b7283c','Rosa':'#df8da8','Blu':'#416b9b','Verde':'#4d765e','Viola':'#75587f','Marrone':'#8a5d47','Arancio':'#d9773d','Giallo':'#d8b94a','Fantasia':'conic-gradient(#d590aa,#5278a8,#d9a34b,#55775d,#d590aa)'}[v]||'#d8d4cc';
    }
    var sizeRank={'XXS':1,'XS':2,'S':3,'M':4,'L':5,'XL':6,'XXL':7,'2XL':7,'3XL':8,'4XL':9};
    var sizes=Array.from(new Set(d.items.filter(function(p){return p.available}).flatMap(function(p){return (p.variants||[]).filter(function(v){return v.available}).map(function(v){return self.sizeOfVariant(v)}).filter(function(v){return v&&String(v).toLowerCase()!=='bandy'})})));
    sizes.sort(function(a,b){
      var aa=String(a).toUpperCase(),bb=String(b).toUpperCase(),ra=sizeRank[aa]||999,rb=sizeRank[bb]||999;
      if(ra!==rb)return ra-rb;
      return a.localeCompare(b,self.locale,{numeric:true,sensitivity:'base'});
    });
    var colorRow=this.root.querySelector('[data-filter-options="'+type+'-color"]');
    var modelRow=this.root.querySelector('[data-filter-options="'+type+'-model"]');
    var sizeRow=this.root.querySelector('[data-filter-options="'+type+'-size"]');
    if(colorRow)colorRow.innerHTML=
      '<button type="button" class="hb-config__filterbtn hb-config__colorbtn hb-config__filterbtn--all is-active" data-filter-button="'+type+'" data-filter-kind="color" data-filter-value=""><i class="hb-config__swatch"></i><span>Tutti</span></button>'+
      colors.map(function(v){return '<button type="button" class="hb-config__filterbtn hb-config__colorbtn" data-filter-button="'+type+'" data-filter-kind="color" data-filter-value="'+esc(v)+'"><i class="hb-config__swatch" style="--hb-swatch:'+swatch(v)+'"></i><span>'+esc(v)+'</span></button>'}).join('');
    if(modelRow)modelRow.innerHTML=
      '<button type="button" class="hb-config__filterbtn is-active" data-filter-button="'+type+'" data-filter-kind="model" data-filter-value="">Tutti</button>'+
      models.map(function(v){return '<button type="button" class="hb-config__filterbtn" data-filter-button="'+type+'" data-filter-kind="model" data-filter-value="'+esc(v)+'">'+esc(v)+'</button>'}).join('');
    if(sizeRow)sizeRow.innerHTML=
      '<button type="button" class="hb-config__filterbtn hb-config__sizefilter is-active" data-filter-button="'+type+'" data-filter-kind="size" data-filter-value="">Tutte</button>'+
      sizes.map(function(v){return '<button type="button" class="hb-config__filterbtn hb-config__sizefilter" data-filter-button="'+type+'" data-filter-kind="size" data-filter-value="'+esc(v)+'">'+esc(v)+'</button>'}).join('');
  };
  Config.prototype.list=function(type){
    var self=this,d=this.data[type],arr=d.items.filter(function(p){return p.available});
    arr=arr.filter(function(p){var pt=String(p.product_type||'').toLowerCase();return !pt||pt===type});
    if(d.query)arr=arr.filter(function(p){return p.title.toLowerCase().indexOf(d.query)>-1});
    if(d.color)arr=arr.filter(function(p){return p.filterColor===d.color});
    if(d.model)arr=arr.filter(function(p){return (p.filterModels||[]).indexOf(d.model)>-1});
    if(d.size)arr=arr.filter(function(p){return (p.variants||[]).some(function(v){return v.available&&self.sizeOfVariant(v)===d.size})});
    return arr;
  };
  Config.prototype.updateScrollArrow=function(type){
    var grid=this.root.querySelector('[data-grid="'+type+'"]'),arrow=this.root.querySelector('[data-scroll-arrow="'+type+'"]');
    if(!grid||!arrow)return;
    var mobile=window.matchMedia&&window.matchMedia('(max-width:749px)').matches;
    if(!mobile){arrow.hidden=true;return}
    var overflow=grid.scrollWidth>grid.clientWidth+8;
    var atEnd=grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-14;
    arrow.hidden=!overflow||atEnd;
  };
  Config.prototype.grid=function(type){
    var self=this,d=this.data[type],grid=this.root.querySelector('[data-grid="'+type+'"]'),more=this.root.querySelector('[data-more="'+type+'"]'),arr=this.list(type);
    var mobile=window.matchMedia&&window.matchMedia('(max-width:749px)').matches;
    var shown=mobile?arr:arr.slice(0,d.visible);
    grid.innerHTML=shown.map(function(p){
      var sel=d.product&&String(d.product.id)===String(p.id);
      return '<button type="button" class="hb-config__card'+(sel?' is-selected':'')+'" data-product="'+esc(p.id)+'" aria-pressed="'+(sel?'true':'false')+'"><span class="hb-config__pic">'+(p.image?'<img loading="lazy" src="'+esc(p.image)+'" alt="'+esc(p.title)+'" width="600" height="800">':'')+'</span><span class="hb-config__copy"><strong>'+esc(p.title)+'</strong><em>'+self.money(p.price)+'</em></span></button>';
    }).join('');
    grid.querySelectorAll('[data-product]').forEach(function(b){b.addEventListener('click',function(){self.select(type,b.dataset.product)})});
    if(more)more.hidden=mobile||arr.length<=d.visible;
    var status=this.root.querySelector('[data-status="'+type+'"]');
    if(d.loaded)status.textContent=arr.length===0?'Nessun modello trovato.':(arr.length===1?'1 modello trovato':arr.length+' modelli trovati');
    requestAnimationFrame(function(){self.updateScrollArrow(type)});
  };
  Config.prototype.select=function(type,id){
    var d=this.data[type],p=d.items.find(function(x){return String(x.id)===String(id)});
    if(!p)return;
    d.product=p;d.variant=null;
    var available=p.variants.filter(function(v){return v.available});
    if(available.length===1)d.variant=available[0];
    this.grid(type);this.choice(type);this.aside();
    this.root.querySelector('[data-choice="'+type+'"]').scrollIntoView({behavior:'smooth',block:'nearest'});
  };
  Config.prototype.choice=function(type){
    var self=this,d=this.data[type],box=this.root.querySelector('[data-choice="'+type+'"]');
    if(!d.product){box.hidden=true;return}
    var p=d.product;
    var sizes=p.variants.map(function(v){var active=d.variant&&String(d.variant.id)===String(v.id);var label=v.title==='Default Title'?'Unica':v.title;return '<button type="button" class="hb-config__size'+(active?' is-selected':'')+'" data-variant="'+esc(v.id)+'" '+(v.available?'':'disabled')+'>'+esc(label)+'</button>'}).join('');
    box.hidden=false;
    box.innerHTML='<div class="hb-config__choicebox">'+(p.image?'<div class="hb-config__choiceimage"><img src="'+esc(p.image)+'" alt="'+esc(p.title)+'" width="900" height="1200"></div>':'<span></span>')+'<div class="hb-config__choiceinfo"><h3>'+esc(p.title)+'</h3><p>'+this.money(p.price)+'</p></div><div class="hb-config__sizes"><b>SCEGLI LA TAGLIA</b>'+sizes+'</div><button type="button" class="button hb-config__next" data-next '+(d.variant?'':'disabled')+'>CONTINUA</button></div>';
    box.querySelectorAll('[data-variant]').forEach(function(b){b.addEventListener('click',function(){var v=p.variants.find(function(x){return String(x.id)===String(b.dataset.variant)});if(v&&v.available){d.variant=v;self.choice(type);self.aside()}})});
    box.querySelector('[data-next]').addEventListener('click',function(){if(!d.variant)return;if(type==='top'){self.go('slip');if(!self.data.slip.items.length)self.load('slip')}else self.go('summary')});
  };
  Config.prototype.go=function(step){
    if(step==='slip'&&!this.data.top.variant)return;
    if(step==='summary'&&(!this.data.top.variant||!this.data.slip.variant))return;
    this.root.querySelectorAll('[data-step]').forEach(function(s){s.hidden=s.dataset.step!==step});
    var order=['top','slip','summary'],now=order.indexOf(step),self=this;
    this.root.querySelectorAll('[data-jump]').forEach(function(b){var i=order.indexOf(b.dataset.jump);b.classList.toggle('is-active',i===now);b.classList.toggle('is-done',i<now);b.disabled=i>now||(b.dataset.jump==='slip'&&!self.data.top.variant)||(b.dataset.jump==='summary'&&!self.data.slip.variant)});
    var mix=this.root.querySelector('[data-mix-preview]');
    var mobile=window.matchMedia&&window.matchMedia('(max-width:749px)').matches;
    if(mix)mix.hidden=!(step==='summary'&&mobile);
    if(step==='summary'){
      this.aside();
      if(!mobile)this.summary();
    }
    this.root.scrollIntoView({behavior:'smooth',block:'start'});
  };
  Config.prototype.aside=function(){
    var self=this,total=0;
    ['top','slip'].forEach(function(type){var d=self.data[type],node=self.root.querySelector('[data-mini="'+type+'"]');if(!d.product)return;var img=d.product.image?'<img src="'+esc(d.product.image)+'" alt="" width="116" height="155">':'<span></span>';node.innerHTML=img+'<div><small>'+type.toUpperCase()+'</small><strong>'+esc(d.product.title)+'</strong>'+(d.variant?'<div>'+esc(d.variant.title)+'</div>':'')+'</div>';if(d.variant)total+=Number(d.variant.price)||0});
    this.root.querySelector('[data-total]').textContent=this.money(total);
  };
  Config.prototype.summary=function(){
    var self=this,node=this.root.querySelector('[data-summary]'),top=this.data.top,slip=this.data.slip,total=Number(top.variant.price)+Number(slip.variant.price);
    function item(type,d){return '<article class="hb-config__sumitem">'+(d.product.image?'<div class="hb-config__sumimage"><img src="'+esc(d.product.image)+'" alt="'+esc(d.product.title)+'" width="900" height="1200"></div>':'')+'<div class="hb-config__suminfo"><small>'+type.toUpperCase()+'</small><h3>'+esc(d.product.title)+'</h3><strong class="hb-config__sumprice">'+self.money(d.variant.price)+'</strong><p>Taglia: '+esc(d.variant.title)+'</p><button type="button" class="link" data-edit="'+type+'">Modifica</button></div></article>'}
    node.innerHTML=item('top',top)+item('slip',slip)+'<div class="hb-config__sumtotal"><span>Totale</span><strong>'+this.money(total)+'</strong></div><div class="hb-config__sumactions"><button type="button" class="button" data-add>ACQUISTA MIX</button><div class="hb-config__cartstatus" data-cartstatus aria-live="polite"></div></div>';
    node.querySelectorAll('[data-edit]').forEach(function(b){b.addEventListener('click',function(){self.go(b.dataset.edit)})});
    node.querySelector('[data-add]').addEventListener('click',function(){self.add(this)});
  };
  Config.prototype.add=async function(button){
    var status=button&&button.hasAttribute('data-mini-add')?this.root.querySelector('[data-mini-cartstatus]'):this.root.querySelector('[data-cartstatus]');
    var base=window.Shopify&&Shopify.routes?Shopify.routes.root:'/';
    button.disabled=true;button.textContent='AGGIUNGO IL MIX…';status.textContent='';
    try{
      var r=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(this.data.top.variant.id),quantity:1,properties:{'_Componi il tuo bikini':'Top'}},{id:Number(this.data.slip.variant.id),quantity:1,properties:{'_Componi il tuo bikini':'Slip'}}]})});
      if(!r.ok)throw new Error('cart');
      status.textContent='Mix aggiunto al carrello.';button.textContent='MIX AGGIUNTO';window.location.assign(base+'cart');
    }catch(e){status.textContent='Qualcosa è andato storto. Riprova.';button.disabled=false;button.textContent='ACQUISTA MIX'}
  };
  document.querySelectorAll('[data-hb-config]').forEach(function(root){if(!root.dataset.ready){root.dataset.ready='1';new Config(root)}})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
